
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.164 4l1.897-1.897 3.835 3.833L16 7.835 12.164 4zm-2.124-.704l.003-.003.003-.003L12.824.512a1.75 1.75 0 012.474 0l4.19 4.187a1.752 1.752 0 010 2.474l-2.743 2.744a1.082 1.082 0 01-.078.078l-8.74 8.743a1.751 1.751 0 01-1.237.512H2.5A1.75 1.75 0 01.75 17.5v-4.19c0-.463.184-.908.512-1.236l8.778-8.778zm4.545 5.953l-8 8.001H2.75v-3.836l8-8 3.835 3.835z","fill":"#282E3E"}})])
          )
        }
      }
    